export default {
  selectedDateMode(state) {
    return state.selectedDateMode;
  },
  dateModeOptions(state) {
    return state.dateModeOptions;
  },
  dataInicial(state) {
    return state.dataInicial;
  },
  dataFinal(state) {
    return state.dataFinal;
  },
  showCharts(state) {
    return state.showCharts;
  },
  isPersonalizado(state) {
    return state.selectedDateMode === 'PERSONALIZADO';
  },
  dateSelection(state) {
    return state.dateSelection;
  },
  empresa(state) {
    return state.empresa;
  },
  centroCusto(state) {
    return state.centroCusto;
  },
  produto(state) {
    return state.produto;
  },
  projeto(state) {
    return state.projeto;
  },
  responsavel(state) {
    return state.responsavel;
  },
  tipoProduto(state) {
    return state.tipoProduto;
  },
  hasCustomFilters(state) {
    return [
      state.empresa,
      state.tipoProduto,
      state.responsavel && state.responsavel.length,
      state.produto && state.produto.length,
      state.centroCusto && state.centroCusto.length,
      state.projeto && state.projeto.length,
    ].some(v => !!v);
  },
  stringFilter(state) {
    const filters = [];

    if (state.empresa && state.empresa.id) {
      filters.push(`(comprador.id = ${state.empresa.id})`);
    }
    if (state.responsavel && state.responsavel.length) {
      const responsaveisFilter = state.responsavel.map(responsavel => `(responsavel.id = ${responsavel.id})`);
      filters.push(`(${responsaveisFilter.join(' or ')})`);
    }
    if (state.centroCusto && state.centroCusto.length) {
      const centroCustosFilter = state.centroCusto.map(centroCusto => `(centroCusto.id = ${centroCusto.id} or produto.centroCusto.id = ${centroCusto.id})`);
      filters.push(`(${centroCustosFilter.join(' or ')})`);
    }
    if (state.produto && state.produto.length) {
      const produtosFilter = state.produto.map(produto => `(produto.id = ${produto.id})`);
      filters.push(`(${produtosFilter.join(' or ')})`);
    }
    if (state.projeto && state.projeto.length) {
      const projetoFilter = state.projeto.map(projeto => `(projeto.id = ${projeto.id} or produto.projeto.id = ${projeto.id})`);
      filters.push(`(${projetoFilter.join(' or ')})`);
    }
    if (state.dateSelection) {
      filters.push(`(dataCompra >= ${state.dateSelection.initialDate} and dataCompra <= ${state.dateSelection.finalDate})`);
    }

    return filters.join(' and ');
  },
};
